import React from 'react';

import { ScoreBoardGrid } from '@/components/scoreboard/ScoreBoardGrid';
import { ScoreboardTeamOverride } from '@/components/scoreboard/types';
import { useScoreboard } from '@/components/scoreboard/use-scoreboard';
import { useEvent } from '@/feature/event-details-sbk/hooks/use-event';
import { Event } from '@/feature/event-details-sbk/types';
import { logger } from '@/utils/logging';

const LOG_TAG = 'EventHudScoreboard';

type EventHudScoreboardProps = {
    pamEventId: string;
    teamOverride?: ScoreboardTeamOverride;
};

const EventHudScoreboardInner = ({ event, teamOverride }: { event: Event; teamOverride?: ScoreboardTeamOverride }) => {
    const scoreboardProps = useScoreboard(event, 'hud', teamOverride);
    if (!scoreboardProps) {
        // An event with period data slipped through gating for a sport without a ScoreBoardGrid
        // builder/variant — wire one up in use-scoreboard.ts + sport-utils.ts.
        logger.warn(LOG_TAG, `no scoreboard builder for sport "${event.sport.name}"`);
        return null;
    }
    return <ScoreBoardGrid {...scoreboardProps} />;
};

export const EventHudScoreboard = ({ pamEventId, teamOverride }: EventHudScoreboardProps) => {
    const { data: event } = useEvent(pamEventId);
    if (!event) return null;
    return <EventHudScoreboardInner event={event} teamOverride={teamOverride} />;
};
